/* ---------------------------------------------------------------------------
   Mega-menu hover behaviour: close delay + switch intent.

   theme.js wires the desktop dropdowns as:
       this.addEventListener('mouseleave', () => this.hideDisclosure());
   i.e. the panel closes the instant the pointer leaves <hover-disclosure>, with
   no grace period. The trigger is only ~50px wide while the panel is full-bleed
   and sits 13px below it, so the natural diagonal from "Um Epal" down-left to a
   link in the first column leaves the trigger before reaching the panel.

   TWO separate things were closing the menu on that diagonal:

   1. the gap  - pointer is briefly over neither trigger nor panel. Fixed by
      delaying the hide (DELAY) instead of firing it immediately.
   2. the siblings - that same diagonal brushes the other top-level triggers
      (Blogg, Vorumerki, Herbergi...) while still in the nav row. Each of those
      is its own hover-disclosure, so entering one switched menus at once and no
      amount of close-delay could help. Fixed by requiring the pointer to settle
      on another trigger for SWITCH ms before the switch commits: brushing past
      does nothing, deliberately hovering still switches.

   Implemented in the CAPTURE phase on document: capture runs top-down before the
   target's own listeners, so stopPropagation() suppresses the theme's handler
   regardless of registration order (this file is deferred). The theme's own
   'theme:disclosure:show' / ':hide' events are then re-issued, so all of its
   normal cleanup and animation still runs.

   Opening the FIRST menu is never delayed - only switching between them is. Only
   mouse events are touched; focusout, Escape and keyboard navigation keep the
   theme's immediate behaviour so keyboard users are never trapped.
   --------------------------------------------------------------------------- */
(function () {
  var DELAY = 400;  // grace period before an open menu closes after the pointer leaves
  var SWITCH = 150; // pointer must settle this long on another trigger before switching

  // Per-menu overrides, keyed by the top-level link's href. Herbergi's panel is a
  // row of five image tiles spread across the full width, so the pointer has much
  // further to travel than in the text-card menus and needs a longer grace period.
  // Add an entry here rather than raising DELAY for everything - a long delay on
  // the short menus just makes them feel sticky.
  var DELAY_BY_HREF = {
    '/collections/herbergi': 700
  };

  function delayFor(el) {
    var link = el.querySelector('.navlink--toplevel');
    var href = link && link.getAttribute('href');
    return (href && DELAY_BY_HREF[href]) || DELAY;
  }

  var pending = new WeakMap();
  var switchTimer = null;
  var switchTarget = null;

  function isDisclosure(el) {
    return !!el && !!el.tagName && el.tagName.toLowerCase() === 'hover-disclosure';
  }
  function cancel(el) {
    var t = pending.get(el);
    if (t) { clearTimeout(t); pending.delete(el); }
  }
  function hideNow(el) {
    cancel(el);
    el.dispatchEvent(new CustomEvent('theme:disclosure:hide'));
  }
  function clearSwitch() {
    if (switchTimer) { clearTimeout(switchTimer); switchTimer = null; }
    switchTarget = null;
  }
  function openMenu() {
    return document.querySelector('hover-disclosure.is-visible');
  }

  document.addEventListener('mouseleave', function (e) {
    var el = e.target;
    if (!isDisclosure(el)) return;
    if (el === switchTarget) clearSwitch();      // left before the switch committed
    if (!el.classList.contains('is-visible')) return;
    e.stopPropagation();                          // suppress the theme's instant hide
    cancel(el);
    pending.set(el, setTimeout(function () { hideNow(el); }, delayFor(el)));
  }, true);

  document.addEventListener('mouseenter', function (e) {
    var el = e.target;
    if (!isDisclosure(el)) return;
    cancel(el);                                   // came back to its own menu: keep it open

    var open = openMenu();
    // Nothing open, or this is already the open one (or nested in it): let the
    // theme open it immediately - the first hover must never feel laggy.
    if (!open || open === el || open.contains(el) || el.contains(open)) { clearSwitch(); return; }

    // A different menu is open: only switch if the pointer settles here.
    e.stopPropagation();
    clearSwitch();
    switchTarget = el;
    switchTimer = setTimeout(function () {
      switchTarget = null;
      switchTimer = null;
      document.querySelectorAll('hover-disclosure.is-visible').forEach(function (other) {
        if (other !== el && !other.contains(el)) hideNow(other);
      });
      el.dispatchEvent(new CustomEvent('theme:disclosure:show'));
    }, SWITCH);
  }, true);
})();
